const LOCAL_STORAGE_PREFIX: string = 'attributestoreadapter-';

export { LOCAL_STORAGE_PREFIX };
